import HandshakeIcon from "@mui/icons-material/Handshake";
import { Box, Button } from "@mui/material";

interface Props {
  onRecordBooking: VoidFunction;
}

export function OffPlatformBookingCancellationPrompt(props: Props) {
  const { onRecordBooking } = props;

  return (
    <Box sx={{ ml: 4, mb: 1 }}>
      <Button
        variant="contained"
        color="success"
        startIcon={<HandshakeIcon />}
        onClick={onRecordBooking}
        sx={{ textTransform: "none", borderRadius: "8px" }}
      >
        Record the booking
      </Button>
    </Box>
  );
}
